import * as React from "react";
import OrderSummaryExpressCheckout from "./OrderSummaryExpressCheckout";
import FinanceAccordion from "./FinanceAccordion";
import LineItem from "./LineItem";
import TrustPilot from "./TrustPilot";
import DiscountForm from "./DiscountForm";
import YouMayAlsoLike from "./YouMayAlsoLike";
import BasketContext from "../services/BasketContext";
import ConfigService from "../services/ConfigService";
import { IInstalments } from "../../../gulp/scripts/typescript/models/IInstalments.model";
import FinanceService from "../../../gulp/scripts/typescript/services/finance-service";
import Logger from "../../../gulp/scripts/typescript/modules/logger";

declare var dataLayer: any;

// Express-checkout A/B test variant of Basket.tsx - identical except it renders
// OrderSummaryExpressCheckout instead of OrderSummary. See OrderSummaryExpressCheckout.tsx.
function BasketExpressCheckout() {

	const basketContext = React.useContext(BasketContext);
	const configService = new ConfigService();
	const financeService = new FinanceService();
	const [financeBanners, setFinanceBanners] = React.useState<IInstalments[]>([]);

	React.useEffect(() => {
		dataLayer = dataLayer || [];

		var items = [];

		for (var i = 0; i < basketContext.basket.LineItems.length; i++) {
			const currentLineItem = basketContext.basket.LineItems[i];
			currentLineItem.ViewItemEventInfo.quantity = currentLineItem.Quantity;
			items.push(currentLineItem.ViewItemEventInfo);
		}

		dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: 'view_cart',
			ecommerce: {
				value: basketContext.basket.Total.Price,
				items: items
			}
		});

	}, []);

	React.useEffect(() => {
		getFinanceBanners();
	}, [basketContext.basket.Total.Price]);

	function getFinanceBanners() {
		financeService.getInstalments(basketContext.basket.Total.Price)
			.then((data) => {
				setFinanceBanners(data);
			})
			.catch((error: Error) => {
				Logger.trackException(error, 'Unknown error in get finance banners endpoint');
			});
	}

	return (
		<div className="c-basket">
			<div className="c-basket__main">
				{basketContext.basket.LineItems.map((lineItem, index)=> {
					return <LineItem {...lineItem} key={lineItem.Guid} />
				})}
				</div>
				<div className="c-basket__sidebar">

					<OrderSummaryExpressCheckout {...basketContext.basket} financeBanners={financeBanners} />
					{configService.imageUrls.klarnaIconUrl || configService.imageUrls.clearpayIconUrl || configService.imageUrls.paypalIconUrl ?
						<div data-test="finance-container">
						{!basketContext.basket.IsTradeCustomer ?
							configService.imageUrls.useFinanceAccordion ?
								<FinanceAccordion financeBanners={financeBanners} amount={basketContext.basket.Total.Price} />
							:
								<React.Fragment>
									{financeBanners.map((item) => {
										return (
											<finance-banner
												provider={item.DisplayName}
												instalmentsMessage={item.InstalmentsMessageFormatted}
												legalMessage={item.LegalMessage}
												howItWorksUrl={item.HowItWorksUrl}
												iconPath={item.IconPath}
												isAvailable={item.IsAvailable}
												amount={basketContext.basket.Total.Price}
												key={item.DisplayName}
											></finance-banner>
										);
									})}
								</React.Fragment>
							: null}
						</div>
					: null}
					<DiscountForm {...basketContext.basket} />
					{!configService.imageUrls.klarnaIconUrl && !configService.imageUrls.clearpayIconUrl ?
						<div className="c-basket__sidebar-item c-basket__sidebar-item--plain">
							<TrustPilot {...basketContext.basket.BasketTrustpilotModel} />
						</div>
					: null}
				</div>
				<YouMayAlsoLike {...basketContext.basket} />
		</div>
	);


}

export default BasketExpressCheckout;
